import {
	Box,
	Button,
	Menu,
	MenuItem,
	Stack,
	ListItemIcon,
	ListItemText,
	IconButton,
	FormControl,
	InputLabel,
	Select,
	MenuItem as MuiMenuItem,
} from "@mui/material";
import {
	CheckCircle,
	HourglassEmpty,
	Cancel,
	MoreVert,
	AddCircleOutline,
	CancelScheduleSend,
	Replay,
	Sort,
	EditCalendar,
	Payments,
} from "@mui/icons-material";
import { useState } from "react";

interface ToolbarGridFilterProposalProps {
	onClickAll: () => void;
	onClickActive: () => void;
	onClickCanceled: () => void;
	selectAll: boolean;
	selectAtive: boolean;
	selectCanceled: boolean;
	textButtonAll: string;
	textButtonActive: string;
	textButtonCanceled: string;
	onLaunchValues?: () => void;
	onCancelBatch?: () => void;
	onReactivateBatch?: () => void; // NOVO
	onAdjustDueDateBatch?: () => void;
	onSetPaidBatch?: () => void;
	sortBy?: "parcel" | "dueDate";
	onChangeSort?: (value: "parcel" | "dueDate") => void;
}

export const ToolbarGridFilterProposal = ({
	onClickAll,
	onClickActive,
	onClickCanceled,
	selectAll,
	selectAtive,
	selectCanceled,
	textButtonAll,
	textButtonActive,
	textButtonCanceled,
	onLaunchValues,
	onCancelBatch,
	onReactivateBatch, // NOVO
	onAdjustDueDateBatch,
	onSetPaidBatch,
	sortBy = "parcel",
	onChangeSort,
}: ToolbarGridFilterProposalProps) => {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const hasMenuActions = Boolean(onLaunchValues || onAdjustDueDateBatch || onSetPaidBatch || onCancelBatch || onReactivateBatch);

	const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleMenuClose = () => setAnchorEl(null);

	return (
		<Box width="100%" mb={2}>
			<Stack direction="row" spacing={1} justifyContent="space-between" alignItems="center">
				<Stack direction="row" spacing={1}>
					<Button
						onClick={onClickAll}
						variant={selectAll ? "contained" : "outlined"}
						color="primary"
						startIcon={<CheckCircle />}
						sx={(theme) => ({
							borderRadius: 3,
							textTransform: "none",
							fontWeight: 400,
							px: 2,
							color: selectAll ? theme.palette.primary.contrastText : "#585858",
							borderColor: "rgba(0, 0, 0, 0.1)",
							backgroundColor: selectAll ? theme.palette.primary.main : "transparent",
							"&:hover": {
								backgroundColor: selectAll ? theme.palette.primary.dark : "rgba(0, 0, 0, 0.03)",
								borderColor: "rgba(0, 0, 0, 0.2)",
							},
						})}
					>
						{textButtonAll}
					</Button>

					<Button
						onClick={onClickActive}
						variant={selectAtive ? "contained" : "outlined"}
						color="success"
						startIcon={<HourglassEmpty />}
						sx={(theme) => ({
							borderRadius: 3,
							textTransform: "none",
							fontWeight: 400,
							px: 2,
							color: selectAtive ? theme.palette.success.contrastText : "#585858",
							borderColor: "rgba(0, 0, 0, 0.1)",
							backgroundColor: selectAtive ? theme.palette.success.main : "transparent",
							"&:hover": {
								backgroundColor: selectAtive ? theme.palette.success.dark : "rgba(0, 0, 0, 0.03)",
								borderColor: "rgba(0, 0, 0, 0.2)",
							},
						})}
					>
						{textButtonActive}
					</Button>

					<Button
						onClick={onClickCanceled}
						variant={selectCanceled ? "contained" : "outlined"}
						color="error"
						startIcon={<Cancel />}
						sx={(theme) => ({
							borderRadius: 3,
							textTransform: "none",
							fontWeight: 400,
							px: 2,
							color: selectCanceled ? theme.palette.error.contrastText : "#585858",
							borderColor: "rgba(0, 0, 0, 0.1)",
							backgroundColor: selectCanceled ? theme.palette.error.main : "transparent",
							"&:hover": {
								backgroundColor: selectCanceled ? theme.palette.error.dark : "rgba(0, 0, 0, 0.03)",
								borderColor: "rgba(0, 0, 0, 0.2)",
							},
						})}
					>
						{textButtonCanceled}
					</Button>
				</Stack>

				<Stack direction="row" spacing={2} alignItems="center">
					<FormControl size="small">
						<InputLabel id="sort-label">Ordenar por</InputLabel>
						<Select
							labelId="sort-label"
							value={sortBy}
							onChange={(e) => onChangeSort?.(e.target.value as "parcel" | "dueDate")}
							label="Ordenar por"
							startAdornment={<Sort fontSize="small" sx={{ mr: 1 }} />}
						>
							<MuiMenuItem value="parcel">Parcela</MuiMenuItem>
							<MuiMenuItem value="dueDate">Vencimento</MuiMenuItem>
						</Select>
					</FormControl>

					{hasMenuActions && (
						<IconButton
							onClick={handleMenuOpen}
							sx={(theme) => ({
								backgroundColor: theme.palette.grey[100],
								"&:hover": {
									backgroundColor: theme.palette.grey[200],
								},
								borderRadius: "50%",
								padding: 1,
							})}
						>
							<MoreVert />
						</IconButton>
					)}
				</Stack>

				{hasMenuActions && (
					<Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
						{onLaunchValues && (
							<MenuItem
								onClick={() => {
									handleMenuClose();
									onLaunchValues();
							}}
						>
							<ListItemIcon>
								<AddCircleOutline fontSize="small" />
							</ListItemIcon>
							<ListItemText primary="Lançar valores" />
						</MenuItem>
					)}

					{onAdjustDueDateBatch && (
						<MenuItem
							onClick={() => {
								handleMenuClose();
								onAdjustDueDateBatch();
							}}
						>
							<ListItemIcon>
								<EditCalendar fontSize="small" />
							</ListItemIcon>
							<ListItemText primary="Ajustar vencimento" />
						</MenuItem>
					)}

					{onSetPaidBatch && (
						<MenuItem
							onClick={() => {
								handleMenuClose();
								onSetPaidBatch();
							}}
						>
							<ListItemIcon>
								<Payments fontSize="small" />
							</ListItemIcon>
							<ListItemText primary="Baixar parcela" />
						</MenuItem>
					)}

					{onCancelBatch && (
						<MenuItem
							onClick={() => {
								handleMenuClose();
								onCancelBatch();
							}}
						>
							<ListItemIcon>
								<CancelScheduleSend fontSize="small" />
							</ListItemIcon>
							<ListItemText primary="Cancelar parcelas em lote" />
						</MenuItem>
					)}

						{onReactivateBatch && (
							<MenuItem
								onClick={() => {
									handleMenuClose();
									onReactivateBatch();
								}}
							>
								<ListItemIcon>
									<Replay fontSize="small" />
								</ListItemIcon>
								<ListItemText primary="Reativar parcelas em lote" />
							</MenuItem>
						)}
					</Menu>
				)}
			</Stack>
		</Box>
	);
};
